var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11487 30.3392C8.34031 25.647 12.8282 22.4443 18 22.4443C23.1718 22.4443 27.6597 25.647 29.8851 30.3392C30.1695 30.9387 30.8453 31.1731 31.3946 30.8629C31.9439 30.5526 32.1588 29.8151 31.8744 29.2156C29.2792 23.7438 24.0412 19.9999 18 19.9999C11.9588 19.9999 6.72075 23.7438 4.12556 29.2156C3.84124 29.8151 4.05608 30.5526 4.60541 30.8629C5.15474 31.1731 5.83055 30.9387 6.11487 30.3392Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 10.9999,
    r: 7,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.2c12a61b0e89aeb8446e4788de780e6b.svg";
export { ForwardRef as ReactComponent };